export function offersPageState<Artist>({
  artistId,
  artist,
}: {
  artistId: string | undefined;
  artist: Artist | null;
}) {
  return {
    artist,
    invalidArtistFilter: Boolean(artistId && !artist),
  };
}

export function offersPageSeoState({
  canonicalPath,
  indexable,
  invalidArtistFilter,
}: {
  canonicalPath: string;
  indexable: boolean;
  invalidArtistFilter: boolean;
}) {
  if (invalidArtistFilter) {
    return { canonicalPath: "/offers", indexable: false };
  }
  return { canonicalPath, indexable };
}

export function hasOffersPageFilters(search: Record<string, unknown>) {
  return Object.values(search).some((value) =>
    Array.isArray(value) ? value.length > 0 : value !== undefined,
  );
}
